import AppShell from "../components/AppShell";
import TileCard from "../components/TileCard";

export default function DashboardPage() {
  return (
    <AppShell
      title="Corporate launchpad for field communication and store operations."
      eyebrow="Launchpad"
      description="The MyEdible Corporate hub for outbound communications and store operations. Each tile launches a purpose-built workflow for the corporate team."
    >
      <section className="section section--tiles">
        <div className="section__header">
          <div>
            <p className="section__eyebrow">Available workflows</p>
            <h2>Choose a tile to launch a corporate tool.</h2>
          </div>
          <p className="section__note">
            Live tiles connect to the store bulk email API. Compose, schedule, and track communications across all ~1,500 franchise and corporate-owned stores.
          </p>
        </div>

        <div className="tiles-grid">
          <TileCard
            title="Store Communications"
            description="Select stores by region, ownership, or franchise group, compose the message, configure delivery options, attach files, and send or schedule the campaign."
            label="Live"
            to="/communications"
          />
          <TileCard
            title="Campaign History"
            description="View all sent campaigns and drafts, track delivery progress per store, retry failed sends, and continue editing saved drafts."
            label="Live"
            to="/campaigns"
          />
          <TileCard
            title="Regional Notices"
            description="Reserved for time-sensitive announcements, operational advisories, and field acknowledgements."
            label="Planned"
            disabled
          />
          <TileCard
            title="Franchise Campaign Center"
            description="Reserved for coordinated marketing pushes with franchise-specific targeting and approval paths."
            label="Planned"
            disabled
          />
          <TileCard
            title="Ops Manual Publisher"
            description="Reserved for publishing operations manual updates directly to the store network."
            label="Planned"
            disabled
          />
          <TileCard
            title="Store Analytics"
            description="Reserved for aggregated store performance metrics, order volumes, and region-level reporting."
            label="Planned"
            disabled
          />
        </div>
      </section>
    </AppShell>
  );
}
